import * as React from "react"
import Faq from "@components/Faq"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

const StrapiFaq = ({
    id,
    content,
    content_images: contentImages,
    faq_items: faqItems
}: GatsbyTypes.FaqFragment) => {
    return <Faq
        id={id}
        content={parseContentImages(
            content,
            contentImages as ParseContentImagesProps[]
        )}
        faqItems={faqItems?.map((faqItem) => ({
            title: `${faqItem?.title}`,
            answer: parseContentImages(
                faqItem?.answer,
                faqItem?.answer_images as ParseContentImagesProps[]
            )
        }))}
    />
}

export default StrapiFaq
